import React from 'react';
import { FormattedMessage } from 'react-intl';
import { GENERAL_SESSIONS, MY_SCHEDULE, REPLAYS } from '../api/custom-pages.dao';
import { FieldInfoMessage } from '../infrastructure/form-viewmodel-controller';

export const myScheduleNotesInfoMessage = <FormattedMessage
    id='oe.defaultPage.mySchedule.infoMessage.myScheduleNotes'
    description='Info message text'
    defaultMessage={`
        My Schedule Notes will appear on the My Schedule page, under the header and above the list of meetings.
    `}
/>;

export const generalSessionsNotesInfoMessage = <FormattedMessage
    id='oe.defaultPage.generalSessions.infoMessage.generalSessionsNotes'
    description='Info message text'
    defaultMessage='General Sessions Notes will appear on the General Sessions page, under the header and above the list of meetings.'
/>;

export const linkDescriptionInfoMessages: FieldInfoMessage = {
    [MY_SCHEDULE]: <FormattedMessage
        id='oe.defaultPage.mySchedule.infoMessage.linkDescription'
        description='Info message text'
        defaultMessage={`
            My Schedule Description will appear on the Welcome page, on the button which links to My Schedule.
            It will only be seen if the Show Link on Welcome Page is enabled.
        `}
    />,
    [REPLAYS]: <FormattedMessage
        id='oe.defaultPage.replays.infoMessage.description'
        description='Info message text'
        defaultMessage={`
                Replays Description will appear on the Welcome page, on the button which links to Replays. It will
                only be seen if the Show Link on Welcome Page is enabled.
        `}
    />,
    [GENERAL_SESSIONS]: <FormattedMessage
        id='oe.defaultPage.generalSessions.infoMessage.description'
        description='Info message text'
        defaultMessage='General Sessions Description will appear on the Welcome page, on the button which links to General Sessions. It will only be seen if the Show Link on Welcome Page is enabled.'
    />,
};

export const sortOrganizationsByInfoMessages = <FormattedMessage
    id='oe.defaultPage.speakers.infoMessage.sortOrganizationsBy'
    description='Info message text'
    defaultMessage={`
            By default, Organizations will be sorted alphabetically.  If you wish to configure the
            order in which the Organizations are listed, choose 'Priority in Event'.  In 'Edit Organization' you can indicate a Priority value for
            each Organization.  Organizations with lower numbers are highest priority and will appear first.  Organizations
            with no Priority value set will appear in alphabetical order below all Organizations with a Priority value.
        `}
/>;

export const replaysNotesInfoMessage = <FormattedMessage
    id='oe.defaultPage.replays.infoMessage.replaysNotes'
    description='Info message text'
    defaultMessage={`
            Replays Notes will appear on the Replays page, under the header and above the sessions.
    `}
/>;
